<template>
  <div class="forecasted-snowfall">
    <br />
    <div class="flex-grid row tc">
      <div class="col">
        <h2 class="ttu forecasted-snowfall-title">
          {{ $t("Forecasted Snowfall") }}
        </h2>
      </div>
    </div>

    <div class="flex-grid row tc">
      <SnowFallDay
        class="col data-block"
        v-for="(day, index) in forecastDays"
        :day="day"
        :key="index"
      />
    </div>
  </div>
</template>

<script>
import SnowFallDay from './SnowFallDay.vue';

export default {
  name: 'SnowFall',
  props: ['forecastDays'],
  components: { SnowFallDay },
};
</script>

<style lang="scss" scoped>
h2 {
  color: $medium-gray;
  font-family: $headline-font-regular;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.2;
}
</style>

<i18n locale="fr-ca">
{
  "Forecasted Snowfall": "Prévision de neige"
}
</i18n>
